import { type GrapeAPIErrorType } from 'components/hooks/GrapeAPIError'

import { EmptyPlanCard } from './Empty'
import { type CoverageType } from '../../../types'

export function ErrorPlanCard ({
  coverageType,
  error,
}: {
  coverageType: CoverageType;
  error?: GrapeAPIErrorType;
}) {
  return (
    <EmptyPlanCard>
      <div className='text-gray-500'>
        <p>A problem occurred while retrieving the {coverageType} plans.<br />Please try again later.</p>
        <br />
        {error?.requestId && <i>Request ID: {error.requestId}</i>}
      </div>
    </EmptyPlanCard>
  )
}

ErrorPlanCard.displayName = 'SmartBudget.PlanCard.Error'
